<template>
  <opt-in-rule-selection
    v-if="field.type === 'selection'"
    :field="field"
    :unchecked-field="uncheckedField"
    @input="$emit('input', $event)"
  />
  <opt-in-rule-options
    v-else
    :field="field"
    :unchecked-field="uncheckedField"
    :error="error"
    @input="$emit('input', $event)"
  />
</template>

<script>
  export default {
    name: 'OptInRuleInput',
    components: {
      OptInRuleSelection: () => import('components/form/optIn/optInRuleSelection'),
      OptInRuleOptions: () => import('components/form/optIn/optInRuleOptions'),
    },
    props: {
      field: {
        type: Object,
        required: true,
        default: null,
      },
      uncheckedField: {
        type: Boolean,
        required: false,
        default: false,
      },
      error: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
  };
</script>
